import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'
import { BaseEditorButton } from '../base-editor-button'

export interface RegistrationButtonProps {
  entity: RegistrationButtonEntityInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const RegistrationButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: RegistrationButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
